export const GRANTS = Object.freeze({
  ACCESS_GROUP_CHANNEL: 'group_channel',
  ACCESS_GROUPS: 'get groups',
  ACCESS_GUEST_REQUEST: 'guest_request',
  ACCESS_HAPPENINGS: 'happenings',
  ACCESS_HOTEL_DIRECTORY: 'hotel_directory',
  ACCESS_IN_ROOM_DINING: 'in_room_dining',
  ACCESS_REPORTING: 'reporting',
  ACCESS_STAYCAST: 'staycast',
  ACCESS_USERS: 'list users',
  ACCOUNT_MANAGEMENT: 'account management',
  ALL_ACCESS: 'all access',
  CREATE_GROUPS: 'create groups',
  CREATE_USERS: 'create users',
  MANAGE_REMOTE_CONTROL_ORDERS: 'manage remote_control_orders',
  SONIFI_ADMIN: 'sonifi: admin',
});
